import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Main from './components/Main';



function App() {
  useEffect(() => {
    document.title = 'Patrik Corri';
  },[]);

  return (
    <>
      <Routes>
        <Route path='/' element={<Main/>}>
        </Route>
      </Routes>
    </>
  )
}

export default App;
